var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{class:_vm.classes,style:({'font-size': _vm.fontSize}),attrs:{"size":_vm.size},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }